// AUTO-GENERATED by scripts/bump-version.mjs
// Do not edit manually.

export const APP_VERSION = process.env.VUE_APP_VERSION || '1.0.66'
export const APP_BUILT_AT = '2026-11-04T09:35:22.134Z'
